module.exports = __webpack_public_path__ + "static/media/galeryAbout8.0064be9e.jpg";